import React from 'react';
import Paper from '@material-ui/core/Paper';
import CanvasJSReact from '../assets/canvasjs.react';
import Button from '@material-ui/core/Button';
import LineChart from './LineChart.js'
import LineChartRegion from './LineChartRegion.js'
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

 
class RegionGroup extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            index: 0
        }
        this._onclick.bind(this)
    }

    _onclick(index){
        this.setState({index: index})
    }


	render() {

    var chart = [
        <LineChart data={this.props.data} />,
        <LineChartRegion data={this.props.data} zone="arsnorte" />,
        <LineChartRegion data={this.props.data} zone="arscentro" />,
        <LineChartRegion data={this.props.data} zone="arslvt" />,
        <LineChartRegion data={this.props.data} zone="arsalentejo" />,
        <LineChartRegion data={this.props.data} zone="arsalgarve" />,
        <LineChartRegion data={this.props.data} zone="madeira" />,
        <LineChartRegion data={this.props.data} zone="acores" />
    ]

    return (
    <div>
        <Paper>
            <Button onClick={() => this._onclick(0)} className={0 === this.state.index ? 'selectedO' : ''}>País</Button>
            <Button onClick={() => this._onclick(1)} className={1 === this.state.index ? 'selectedO' : ''}>Norte</Button>
            <Button onClick={() => this._onclick(2)} className={2 === this.state.index ? 'selectedO' : ''}>Centro</Button>
            <Button onClick={() => this._onclick(3)} className={3 === this.state.index ? 'selectedO' : ''}>Lisboa</Button>
            <Button onClick={() => this._onclick(4)} className={4 === this.state.index ? 'selectedO' : ''}>Alentejo</Button>
            <Button onClick={() => this._onclick(5)} className={5 === this.state.index ? 'selectedO' : ''}>Algarve</Button>
            <Button onClick={() => this._onclick(6)} className={6 === this.state.index ? 'selectedO' : ''}>Madeira</Button>
            <Button onClick={() => this._onclick(7)} className={7 === this.state.index ? 'selectedO' : ''}>Açores</Button>

            {chart[this.state.index]}
        </Paper>
    </div>
    );
	}
}

export default RegionGroup;                           